import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportCashierV2PageRoutingModule } from './report-cashier-v2-routing.module';

import { ReportCashierV2Page } from './report-cashier-v2.page';
@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      IonicModule,
      ReactiveFormsModule,
      ReportCashierV2PageRoutingModule
  ],
  declarations: [ReportCashierV2Page]
})
export class ReportCashierV2PageModule {}
